import { FunctionComponent } from 'react';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { SearchComponent } from 'components/UI';

interface SearchProperties {
    onSearch: (test: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: 20,
            padding: '0px 25px',
            [theme.breakpoints.down('md')]: {
                paddingLeft: 0,
                paddingRight: 0
            },
            paddingLeft: 30,
            paddingRight: 30
        },
        box: {
            width: '100%',
            borderRadius: 12,
            padding: '15px 20px',
            backgroundColor: '#F1F1F1',
            marginTop: 20,
            [theme.breakpoints.down('sm')]: {
                padding: '15px 15px'
            }
        },
        field: {
            'height': 47,
            '& .MuiInputBase': {
                '&-root': {
                    backgroundColor: '#fff',
                    width: '40%',
                    [theme.breakpoints.down('sm')]: {
                        width: '100%'
                    }
                },
                '&-input': {
                    fontSize: 14
                }
            },
            '& .MuiInputAdornment-root': {
                'opacity': 0.3,
                'pointer-events': 'none',

                '& svg': {
                    cursor: 'default'
                },
                [theme.breakpoints.down('md')]: {
                    'opacity': 1,
                    '& svg': {
                        color: '#000',
                        fontWeight: 400
                    }
                }
            }
        }
    })
);

const Search: FunctionComponent<SearchProperties> = props => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Box className={classes.box}>
                <SearchComponent
                    open
                    onSearch={props.onSearch}
                    className={classes.field}
                    placeholder="Search by service name"
                />
            </Box>
        </Box>
    );
};

export default Search;
